import React, { useEffect, useCallback, useState } from "react";
import { useSelector } from "react-redux";
import Modal from "react-modal";
import axios from "axios";
import SummarySection from "./dashboard/SummarySection";
import CommissionSection from "./dashboard/CommissionSection";
import CretaSection from "./dashboard/CretaSection";
import StakingSection from "./dashboard/StakingSection";
import InvestModal from "./dashboard/InvestModal";
import StakingModal from "./dashboard/StakingModal";
import StakingListModal from "./dashboard/StakingListModal";
import CretaBuyModal from "./dashboard/CretaBuyModal";

import Nav from "./Nav";
import Loading from "./Loading";
import { buildTimestamp } from "../App.js";

function DashBoard() {
  const address = useSelector((state) => state.address.value);
  const [isLoading, setLoading] = useState(true);
  const [isInvestModalOpen, setInvestModalOpen] = useState(false);
  const [isStakingModalOpen, setStakingModalOpen] = useState(false);
  const [isStakingListModalOpen, setStakingListModalOpen] = useState(false);
  const [isCretaBuyModalOpen, setCretaBuyModalOpen] = useState(false);

  const [userInfo, setUserInfo] = useState({});
  const [userMatic, setUserMatic] = useState();
  const [profitData, setProfitData] = useState({
    profit: 0,
    referral: 0,
    sponsor: 0,
    matching: 0,
    status: 0,
    deposit: 0,
  });
  const [creta, setCreta] = useState(0);
  const [RankData, setRankData] = useState("");
  const [referralDownLine, setReferralDownLine] = useState({
    left: 0,
    right: 0,
  });
  const [sponsorDownLine, setSponsorDownLine] = useState({ left: 0, right: 0 });

  const getUserInfo = useCallback(async () => {
    let addr = address;
    if (!!window.TEST_ADDRESS && window.TEST_ADDRESS.length == 34) {
      addr = window.TEST_ADDRESS;
      console.log(">>>>>>> testAddress: ", addr);
    }
    axios
      .post("api/userInfo", {
        address: addr,
        buildTimestamp,
      })
      .then((res) => {
        const data = res.data;

        setUserInfo(data);
        setUserMatic(data.matic_address);
        setRankData(data.rank);
        setCreta(data.creta);
        setProfitData({
          profit: data.profit,
          referral: data.referral_profit,
          sponsor: data.sponsor_profit,
          matching: data.matching_profit,
          status: data.status_profit,
          deposit: data.deposit,
        });
        setReferralDownLine({
          left: data.referral_left_deposit,
          right: data.referral_right_deposit,
        });

        setSponsorDownLine({
          left: data.sponsor_left_deposit,
          right: data.sponsor_right_deposit,
        });
        setLoading(false);
      })
      .catch((err) => {
        if (err.response) {
          console.log(err.response);
          console.log(err.response.data.message);
        }
      });
  }, [address]);

  const refreshPage = useCallback(async () => {
    if (!address) {
      return;
    }
    getUserInfo();
  }, [getUserInfo, address]);

  useEffect(() => {
    refreshPage();
    return () => {};
  }, [refreshPage]);

  if (isLoading) {
    return <Loading />;
  } else {
    return (
      <div id="dashboard" className="sub-container">
        <div className="content">
          <SummarySection
            refreshPage={refreshPage}
            address={address}
            profitData={profitData}
            setInvestModalOpen={setInvestModalOpen}
            userInfo={userInfo}
            referralDownLine={referralDownLine}
            sponsorDownLine={sponsorDownLine}
            RankData={RankData}
          />
          <CretaSection
            refreshPage={refreshPage}
            address={address}
            profitData={profitData}
            userInfo={userInfo}
            creta={creta}
            userMatic={userMatic}
            setCretaBuyModalOpen={setCretaBuyModalOpen}
          />
          <StakingSection
            refreshPage={refreshPage}
            address={address}
            profitData={profitData}
            userInfo={userInfo}
            creta={creta}
            userMatic={userMatic}
            setStakingModalOpen={setStakingModalOpen}
            setStakingListModalOpen={setStakingListModalOpen}
          />
          <CommissionSection
            refreshPage={refreshPage}
            address={address}
            profitData={profitData}
          />
          <Modal
            closeTimeoutMS={200}
            isOpen={isInvestModalOpen}
            onRequestClose={() => setInvestModalOpen(false)}
            ariaHideApp={false}
          >
            <InvestModal
              refreshPage={refreshPage}
              userInfo={userInfo}
              creta={creta}
              setInvestModalOpen={setInvestModalOpen}
              profitData={profitData}
              setLoading={setLoading}
            />
          </Modal>
          <Modal
            closeTimeoutMS={200}
            isOpen={isStakingModalOpen}
            onRequestClose={() => setStakingModalOpen(false)}
            ariaHideApp={false}
          >
            <StakingModal
              refreshPage={refreshPage}
              address={address}
              userInfo={userInfo}
              creta={creta}
              profitData={profitData}
              setLoading={setLoading}
              setStakingModalOpen={setStakingModalOpen}
            />
          </Modal>
          <Modal
            closeTimeoutMS={200}
            isOpen={isStakingListModalOpen}
            onRequestClose={() => setStakingListModalOpen(false)}
            ariaHideApp={false}
          >
            <StakingListModal
              refreshPage={refreshPage}
              address={address}
              userInfo={userInfo}
              creta={creta}
              profitData={profitData}
              setLoading={setLoading}
              setStakingModalOpen={setStakingListModalOpen}
            />
          </Modal>

          <Modal
            closeTimeoutMS={200}
            isOpen={isCretaBuyModalOpen}
            onRequestClose={() => setCretaBuyModalOpen(false)}
            ariaHideApp={false}
          >
            <CretaBuyModal
              refreshPage={refreshPage}
              address={address}
              userInfo={userInfo}
              creta={creta}
              profitData={profitData}
              setLoading={setLoading}
              setCretaBuyModalOpen={setCretaBuyModalOpen}
            />
          </Modal>
        </div>
        <Nav />
      </div>
    );
  }
}

export default DashBoard;
